// ページ編集の在席表示。
// editing=true (edit 画面) なら自分を編集者として登録し、
// editing=false (show 画面) なら購読のみ。受信した編集者一覧から
// 自分を除いてチップを描画する。
import { Controller } from "@hotwired/stimulus"
import { cable } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { pageId: Number, editing: Boolean, selfId: Number }

  async connect() {
    const consumer = await cable.getConsumer()
    this.subscription = consumer.subscriptions.create(
      { channel: "EditingPresenceChannel", page_id: this.pageIdValue, editing: this.editingValue },
      { received: (data) => this.render(data.editors || []) }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
  }

  render(editors) {
    const others = editors.filter((e) => Number(e.id) !== this.selfIdValue)
    if (others.length === 0) {
      this.element.innerHTML = ""
      return
    }
    const names = others.map((e) => this.escape(e.name)).join("、")
    const suffix = this.editingValue ? "も編集中です — 保存時に競合する可能性があります" : "が編集中"
    this.element.innerHTML = `
      <span class="akebono-editing-chip${this.editingValue ? " akebono-editing-chip--warn" : ""}">
        <span class="akebono-editing-dot"></span>${names} さん${suffix}
      </span>`
  }

  escape(s) {
    const d = document.createElement("div")
    d.textContent = s ?? ""
    return d.innerHTML
  }
}
